import { Component, OnInit } from '@angular/core';
import { Vendor } from '../vendor';
import { VendorService } from '../vendor.service';

import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StateService } from '../../state/state.service';
import { State } from '../../state/state';
import { City } from '../../city/city';
import { CityService } from '../../city/city.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../auth.service';


@Component({
  selector: 'app-create-vendor',
  templateUrl: './create-vendor.component.html',
  styleUrls: ['./create-vendor.component.css']
})
export class CreateVendorComponent implements OnInit {

  vendor = new Vendor();
  vendordata : any = {}
  submitted = false;
  cities: City[];
  states: State[];
  message: string;
  vendorForm: FormGroup;
  public isupdate = false;
public FormName = "Add Vendor";
mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
pancardPattern = "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$";
gstPattern = "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$";

  constructor(
    private vendorService: VendorService,
    private cityService: CityService,
    private stateService: StateService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.vendor.active = 1;
    this.getStates();
    this.getcities();
    if(this.route.snapshot.paramMap.get('vendorId') != null)
			{
        const vendorId = +this.route.snapshot.paramMap.get('vendorId');
				 if(vendorId > 0)
				 {
					 this.getVendor(vendorId);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Vendor";
				 
			}
    this.vendorForm = this.formBuilder.group({			
      vendorname: [this.vendor.vendorname,[Validators.required, Validators.required]],
      vendoraddress: [this.vendor.vendoraddress,[Validators.required, Validators.required]],
      stateid: [this.vendor.stateid,[Validators.required, Validators.required]],
      cityid: [this.vendor.cityid,[Validators.required, Validators.required]],
      pincode: [this.vendor.pincode,[Validators.required, Validators.required]],
      vendorphone: [this.vendor.vendorphone,[Validators.required, Validators.pattern(this.mobnumPattern)]],
      vendormailid: [this.vendor.vendormailid,[Validators.required, Validators.email,Validators.pattern(this.emailPattern)]],
      gstno: [this.vendor.gstno,[Validators.required, Validators.required, Validators.pattern(this.gstPattern)]],
      panno: [this.vendor.panno,[Validators.required, Validators.required, Validators.pattern(this.pancardPattern)]],
     hsncode: [this.vendor.hsncode],
     active: [this.vendor.active,[Validators.required, Validators.required]]
    });	
  }
// convenience getter for easy access to form fields
get f() {
  return this.vendorForm.controls
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.vendorForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.updateVendor();
    }
    else{
      this.addVendor();
    }
  }
}

  public addVendor() {
    this.save();
  }
  public updateVendor() {
    this.update();
  }
  
private save(): void {
  this.vendordata = this.vendor;
   this.vendordata.createdby = this.auth.currentUserValue.userid
  this.vendorService.addVendor(this.vendordata).subscribe(() => 
  { 
  this.util.showSuccess("Vendor added successfully.");
  this.router.navigate(['/vendors-list']);
  });
  // this.goBack();  //for Redirecting to the list view     
}

update(): void {
  //this.submitted = true;
  this.submitted = true;
  this.vendordata = this.vendor;
  this.vendordata.modifiedby = this.auth.currentUserValue.userid;
  this.vendordata.modifiedon = Date.now();
  this.vendorService.updateVendor(this.vendordata)
      .subscribe(() => 
	  { 
	  this.util.showSuccess("Vendor update successfully.");
      this.router.navigate(['/vendors-list']);
	  });
}



  getStates() {
    return this.stateService.getStates()
               .subscribe(
                 states => {
                  console.log(states);
                  this.states = states.filter(item => item.active == 1);
                 }
                );
 }
 
 getcities() {
  return this.cityService.getCities()
             .subscribe(
              cities => {
                console.log(cities);
                this.cities = cities.filter(item => item.active == 1);
               }
              );
}

 getVendor(vendorid) {
  return this.vendorService.getVendor(vendorid)
             .subscribe(
               vendor => {
                console.log(vendor);
                this.vendor = vendor
                //this.getCityByState(this.vendor.stateid);
               }
              );
}
public onStateChangeObj(filterstateID){
	//	this.FiltercityArray =  this.cityArray.filter(c => c.stateid === filterstateID);
		this.getCityByState(filterstateID);
  }
  
getCityByState(stateid) {
  return this.cityService.getCityByState(stateid)
             .subscribe(
               cities => {
                console.log(cities);                  
                this.cities = cities
               }
              );
  }
}
